__turbopack_context__.v({
  "originalPrice": "QzHlwa_originalPrice",
  "previousPrice": "QzHlwa_previousPrice",
  "priceBox": "QzHlwa_priceBox",
  "supportingText": "QzHlwa_supportingText",
  "wrapper": "QzHlwa_wrapper",
});
